<template>
  <modal name="notesModal" height="auto" :scrollable="true">
    <div class="position-relative modal-outer-container">
      <div class="modal-header border-bottom">
        <div class="ml-3 pl-2">
          {{ title || "Additional Notes" }}
        </div>
        <button class="btn border-0" @click="hide">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="notes-container">
          <input-control
            :value="notes"
            wrapClass="mb-0"
            control="textarea"
            type="horizontal"
            textareaClass="border-0"
            labelClass="d-none"
            inputClass="disabled"
            >Additional Notes</input-control
          >
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "NotesModal",
  props: {
    notes: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Additional Notes",
    },
  },
  methods: {
    show() {
      this.$modal.show("notesModal");
    },
    hide() {
      this.$modal.hide("notesModal");
    },
  },
};
</script>
<style scoped lang="scss">
.notes-container {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #d2ddec;
  border-radius: 16px;
}
</style>
